module.exports = __webpack_public_path__ + "static/save-time-plumber-0395c865184358ca802dcedcedebdd77.jpg";